import { render, staticRenderFns } from "./invoice1.vue?vue&type=template&id=d725ff12&scoped=true"
import script from "./invoice1.vue?vue&type=script&lang=js"
export * from "./invoice1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d725ff12",
  null
  
)

export default component.exports